import { render } from "./SlideShow.vue?vue&type=template&id=39907362&scoped=true"
import script from "./SlideShow.vue?vue&type=script&lang=js"
export * from "./SlideShow.vue?vue&type=script&lang=js"

import "./SlideShow.vue?vue&type=style&index=0&id=39907362&scoped=true&lang=css"

import exportComponent from "/home/tantonj/Documents/GitHub/TantonSoftwareSolutions/tantonsoftwaresolutions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39907362"]])

export default __exports__